import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ZavicService } from 'src/app/services/zavic.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-zavic',
  templateUrl: './create-zavic.component.html',
  styleUrls: ['styles.css']
})
export class CreateZavicComponent implements OnInit {

  public items=[];
  
  
  public zavicForm = this.fb.group({
    title: ['', Validators.required],
    opcA: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcB: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcC: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    opcD: this.fb.group({
      text:['', Validators.required],
      value:[1]
    }) ,
    type: ['', Validators.required],
    order:['', Validators.required]
  });
  constructor(private fb: FormBuilder, private zavicService: ZavicService) {

    this.items[0]="";
    this.items[1]="";
    this.items[2]="";
    this.items[3]="";

   }

  ngOnInit(): void {

  }

  register(){
    this.zavicForm.controls['order'].setValue(this.items);
    if (!this.zavicForm.invalid){
      
      this.zavicService.createQuestion(this.zavicForm.value).subscribe(
        resp=>{
          this.zavicForm.reset();
          let timerInterval
          Swal.fire({
            title: 'Pregunta creada',
            html: '',
            timer: 1000,
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading()
            },
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              
            }
          })
        },
        err=>console.log(err)
  
  
      )
    }else{
      let timerInterval
          Swal.fire({
            title: 'Revise los campos',
            html: '',
            timer: 1000,
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading()
            },
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              
            }
          })
    }
  }

  reset(){
    this.zavicForm.reset();
  }

}
